module.exports = __webpack_public_path__ + "static/helm_of_comprehending_languages-41566befcc31d960ab3853f144784733.jpeg";